import React, { useState } from "react";
import QueryDefinition from "./queryDefinition";
import paths from "@icarius-router/paths";
import { QueryDefinitionParameters } from "@icarius-pages/queryDefinitionParameters";

const QueryDefinitionSwitch = ({ history }) => {

  const [parametersIsOpen, setParametersIsOpen] = useState(false);
  const [parameter, setParameter] = useState(null);

  const handleOpenParameterPage = (process) => {
    setParameter(process);
    setParametersIsOpen(true);
  }

  const handleGoBack = () => {
    history.push(paths.managementDefinition);
  }

  return (
    <>
      {
        parametersIsOpen ?
          <QueryDefinitionParameters
            parameter={parameter}
            handleGoBack={() => setParametersIsOpen(false)}
          />
          :
          <QueryDefinition
            handleGoBack={handleGoBack}
            handleOpenParameterPage={handleOpenParameterPage}
          />
      }
    </>
  );
}

export default QueryDefinitionSwitch;
